// Parsers drop control characters and rewrite backslashes, so "/\t/evil.com" leaves the site
const hasUnsafeCharacter = (value: string): boolean =>
  Array.from(value).some((char) => {
    const code = char.charCodeAt(0);
    return code < 0x20 || code === 0x7f || char === '\\';
  });

/** Only paths inside this app are followed, so crafted sign-in state can't redirect off-site */
export const toSafeReturnPath = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  if (hasUnsafeCharacter(value)) return null;
  return value;
};
